<template>
  <div class="page--404">
    <h1>404</h1>
    <p class="pathname">{{pathname}}</p>
  </div>
</template>

<script>
export default {
  computed: {
    pathname() {
      return location.pathname;
    }
  }
};
</script>
